import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const DowloadDeviceLocationExample = ({ property = [], tableRef, t }) => {
    const data = [
        {
            old_device_cd: 'MSE230 Ø8X20',
            device_nm: '8FX20',
            name_supplier: 'NCC3',
            arrDepartments: [
                {
                    label: 'RESEARCH AND DEVELOPMENT DEPARTMENT',
                    value: 'RDDEV',
                },
                {
                    label: 'ADMIN',
                    value: 'admin',
                },
            ],
            price: 911000,
            status_device: '1',
            checking_after: '',
            can_grinding: 1,
            old_cabinet_cd: 'CBNV3002',
            old_drawer_lc: 19,
            cell_lc_nums_old: '{"row": 1, "column": 1}',
            cell_lc_nums_new: '{"row": 1, "column": 3}',
            arrProperties: [
                {
                    label: 'Nhà sản xuất',
                    value: 'Sumitomo',
                },
                {
                    label: 'Trong / Ngoài',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Loại',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Tiện',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Số cạnh',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Phi Ø',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Bán kính góc RE',
                    value: '0.4',
                },
                {
                    label: 'Chiều rộng cắt CW',
                    value: '2.5',
                },
                {
                    label: 'Bước',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Nhiệt luyện',
                    value: 'Chưa rõ',
                },
            ],
            cabinet_type_old: 'circle',
            cabinet_type_new: 'circle',
        },
        {
            old_device_cd: '2NU-DCGW11T304(BN7000)_ML02',
            device_nm: 'TIỆN HỢP KIM',
            name_supplier: 'NCC010',
            arrDepartments: [
                {
                    label: 'TIỆN CNC',
                    value: 'LN',
                },
                {
                    label: 'TIỆN CƠ',
                    value: 'LA',
                },
                {
                    label: 'PHAY CNC',
                    value: 'MN',
                },
                {
                    label: 'PHAY CƠ',
                    value: 'MI',
                },
                {
                    label: 'RESEARCH AND DEVELOPMENT DEPARTMENT',
                    value: 'RDDEV',
                },
                {
                    label: 'VĂN PHÒNG',
                    value: 'VP',
                },
                {
                    label: 'MAINTENANCE DEPARTMENT',
                    value: 'VIPPRO',
                },
                {
                    label: 'QUẢN LÝ CAO CẤP',
                    value: 'BOSS',
                },
                {
                    label: 'ADMIN',
                    value: 'admin',
                },
            ],
            price: 12,
            status_device: '1',
            checking_after: '',
            can_grinding: 1,
            old_cabinet_cd: 'CBNV3002',
            old_drawer_lc: 19,
            cell_lc_nums_old: '{"row": 1, "column": 1}',
            new_drawer_lc: 18,
            cell_lc_nums_new: '{"row": 1, "column": 2}',
            arrProperties: [
                {
                    label: 'Nhà sản xuất',
                    value: 'Sumitomo',
                },
                {
                    label: 'Trong / Ngoài',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Loại',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Tiện',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Số cạnh',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Phi Ø',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Bán kính góc RE',
                    value: '0.4',
                },
                {
                    label: 'Chiều rộng cắt CW',
                    value: '2.5',
                },
                {
                    label: 'Bước',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Nhiệt luyện',
                    value: 'Chưa rõ',
                },
            ],
            cabinet_type_old: 'circle',
            cabinet_type_new: 'circle',
        },
        {
            old_device_cd: 'TEST',
            device_nm: 'TEST',
            name_supplier: 'NCC017',
            arrDepartments: [
                {
                    label: 'PHAY CNC MISUMI',
                    value: 'MNMSM',
                },
                {
                    label: 'ADMIN',
                    value: 'admin',
                },
            ],
            price: 2000,
            status_device: '1',
            checking_after: '',
            can_grinding: 0,
            old_cabinet_cd: 'CBNV3002',
            old_drawer_lc: 1,
            cell_lc_nums_old: '{"row": 1, "column": 12}',
            new_cabinet_cd: 'CBNV3002',
            new_drawer_lc: 20,
            cell_lc_nums_new: '{"row": 1, "column": 9}',
            arrProperties: [
                {
                    label: 'Tiện',
                    value: 'Tinh',
                },
            ],
            cabinet_type_old: 'circle',
            cabinet_type_new: 'circle',
        },
        {
            old_device_cd: 'TEST',
            device_nm: 'TEST',
            name_supplier: 'NCC017',
            producer: 'Chưa rõ',
            arrDepartments: [
                {
                    label: 'PHAY CNC MISUMI',
                    value: 'MNMSM',
                },
                {
                    label: 'ADMIN',
                    value: 'admin',
                },
            ],
            price: 2000,
            status_device: '1',
            checking_after: '',
            can_grinding: 0,
            old_cabinet_cd: 'CBNV3002',
            old_drawer_lc: 2,
            cell_lc_nums_old: '{"row": 1, "column": 6}',
            new_drawer_lc: 10,
            cell_lc_nums_new: null,
            arrProperties: [
                {
                    label: 'Tiện',
                    value: 'Tinh',
                },
            ],
            cabinet_type_old: 'circle',
            cabinet_type_new: 'circle',
        },
        {
            old_device_cd: '16ER200ISO(PR1115)_ML02',
            device_nm: 'TIỆN REN NGOÀI B 2',
            name_supplier: 'NCC004',
            arrDepartments: [
                {
                    label: 'TIỆN CNC',
                    value: 'LN',
                },
                {
                    label: 'TIỆN CƠ',
                    value: 'LA',
                },
                {
                    label: 'PHAY CNC',
                    value: 'MN',
                },
                {
                    label: 'PHAY CƠ',
                    value: 'MI',
                },
                {
                    label: 'RESEARCH AND DEVELOPMENT DEPARTMENT',
                    value: 'RDDEV',
                },
                {
                    label: 'VĂN PHÒNG',
                    value: 'VP',
                },
                {
                    label: 'MAINTENANCE DEPARTMENT',
                    value: 'VIPPRO',
                },
                {
                    label: 'QUẢN LÝ CAO CẤP',
                    value: 'BOSS',
                },
                {
                    label: 'ADMIN',
                    value: 'admin',
                },
            ],
            price: 13000,
            status_device: '1',
            checking_after: '',
            can_grinding: 0,
            old_cabinet_cd: 'CBNOHN011',
            old_drawer_lc: 3,
            cell_lc_nums_old: '{"row": 5, "column": 3}',
            new_drawer_lc: 8,
            cell_lc_nums_new: null,
            arrProperties: [
                {
                    label: 'Nhà sản xuất',
                    value: 'Kyocera',
                },
                {
                    label: 'Trong / Ngoài',
                    value: 'Ngoài',
                },
                {
                    label: 'Loại',
                    value: 'Ren',
                },
                {
                    label: 'Tiện',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Số cạnh',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Phi Ø',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Bán kính góc RE',
                    value: '0.25',
                },
                {
                    label: 'Chiều rộng cắt CW',
                    value: 'Chưa rõ',
                },
                {
                    label: 'Bước',
                    value: '2',
                },
                {
                    label: 'Nhiệt luyện',
                    value: 'Chưa rõ',
                },
            ],
            cabinet_type_old: 'square',
            cabinet_type_new: 'square',
        },
    ];
    return (
        <TableContainer ref={tableRef} sx={{}} style={{ display: 'none' }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('device_cd_old')}*</TableCell>
                        <TableCell>{t('device_cd_new')}</TableCell>
                        <TableCell>{t('name_device')}*</TableCell>
                        <TableCell>{t('code_supplier')}*</TableCell>
                        <TableCell>{t('producer')}*</TableCell>
                        <TableCell>{t('quan_ly_bo_phan')}*</TableCell>
                        <TableCell>{t('price')}*</TableCell>
                        <TableCell>{t('status_device')}*</TableCell>
                        <TableCell>{t('checking_after')}</TableCell>
                        <TableCell>{t('can_grinding')}*</TableCell>
                        <TableCell>{t('cabinet_code_old')}*</TableCell>
                        <TableCell>{t('id_drawer_old')}*</TableCell>
                        <TableCell>{t('cell_old')}*</TableCell>
                        <TableCell>{t('cabinet_code_new')}</TableCell>
                        <TableCell>{t('id_drawer_new')}</TableCell>
                        <TableCell>{t('cell_new')}</TableCell>
                        {property?.length > 0 &&
                            property.map((item, index) => (
                                <TableCell key={index} align="right">
                                    {item?.label}
                                </TableCell>
                            ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map((row, idx) => {
                        // parse cell nếu là JSON string
                        const cellOld = row.cell_lc_nums_old ? JSON.parse(row.cell_lc_nums_old) : null;
                        const cellNew = row.cell_lc_nums_new ? JSON.parse(row.cell_lc_nums_new) : null;

                        return (
                            <TableRow key={idx}>
                                <TableCell>{row.old_device_cd ?? ''}</TableCell>
                                <TableCell>{row.device_cd_new ?? ''}</TableCell>
                                <TableCell>{row.device_nm ?? ''}</TableCell>
                                <TableCell>{row.name_supplier ?? ''}</TableCell>
                                <TableCell>{row.producer ?? ''}</TableCell>
                                <TableCell>
                                    {Array.isArray(row.arrDepartments)
                                        ? row.arrDepartments.map((d) => d.value).join(', ')
                                        : ''}
                                </TableCell>
                                <TableCell>{row.price ?? ''}</TableCell>
                                <TableCell>{row.status_device ?? ''}</TableCell>
                                <TableCell>{row.checking_after ?? ''}</TableCell>
                                <TableCell>{row.can_grinding ?? ''}</TableCell>
                                <TableCell>{row.old_cabinet_cd ?? ''}</TableCell>
                                <TableCell>{row.old_drawer_lc ?? ''}</TableCell>
                                {row.cabinet_type_new ? (
                                    row.cabinet_type_new === 'square' ? (
                                        <TableCell>
                                            {cellOld?.row} : {cellOld?.column}
                                        </TableCell>
                                    ) : (
                                        <TableCell>{cellOld?.column}</TableCell>
                                    )
                                ) : (
                                    <TableCell>{''}</TableCell>
                                )}
                                <TableCell>{row.new_cabinet_cd ?? ''}</TableCell>
                                <TableCell>{row.new_drawer_lc ?? ''}</TableCell>
                                {row.cabinet_type_new ? (
                                    row.cabinet_type_new === 'square' ? (
                                        <TableCell>
                                            {cellNew?.row} : {cellNew?.column}
                                        </TableCell>
                                    ) : (
                                        <TableCell>{cellNew?.column}</TableCell>
                                    )
                                ) : (
                                    <TableCell>{''}</TableCell>
                                )}
                                {property?.length > 0 &&
                                    property.map((item, index) => (
                                        <TableCell key={index} align="right">
                                            {row.arrProperties?.find((p) => p.label === item.label)?.value || ''}
                                        </TableCell>
                                    ))}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DowloadDeviceLocationExample;
